import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const DocumentationImage = props => (
    <SvgIcon {...props}>
        <path
            d="M13.768 2.411c.319 0 .578.252.59.569l.001.024V16H.77V3.004c0-.32.252-.58.567-.593h12.431zM16.003 0v14.356c0 .683-.417 1.269-1.01 1.517V2.38a.593.593 0 00-.592-.595H2.852V.595c0-.329.265-.595.592-.595h12.559zm-9.62 13.67H4.02a.296.296 0 00-.02.592h2.383a.296.296 0 000-.592zm4.726-3.555H4.02a.296.296 0 00-.018.592h7.109a.296.296 0 000-.592zm0-3.556H4.02a.296.296 0 00-.018.592h7.109a.296.296 0 000-.592z"
            stroke="none"
            fillRule="nonzero"
        />
    </SvgIcon>
);

export default DocumentationImage;
